import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/ConditionalChildren/ConditionalChildrenUsage.mdx";

import Examples from "../../Docs/Components/ConditionalChildren/ConditionalChildrenExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="ConditionalChildren"
            description="Display or hide groups of elements conditionally using a conditional children element."
            apiSources={["azure-devops-ui/Components/ConditionalChildren/ConditionalChildren.Props.d.ts"]}
            examples={Examples}
            usage={Usage}
        />
    );
}
}
        
export default Page;